import Vue from 'vue';
import BASE_CONSTANTS from '@/constants/baseConstants';
import BigNumber from 'bignumber.js';
export default Vue.extend({
    name: 'spotItem',
    props: {
        name: {
            type: String,
            required: true
        },
        val: {
            type: String,
            required: true
        },
        valInUSDT: {
            type: String,
            required: true
        },
        letConvert: {
            type: Boolean,
            required: true
        },
        locked: {
            type: Boolean,
            required: true
        },
        id: {
            type: [Number, String],
            required: true
        },
        isFolder: {
            type: Boolean,
            required: true
        },
        selected: {
            type: Boolean,
            required: true
        },
        inDefaultFolder: {
            type: Boolean,
            required: true
        },
        index: {
            type: Number,
            required: true
        },
        folderIndex: {
            type: Number,
            required: true
        },
        folderID: {
            type: Number,
            required: true
        },
        isLastItem: {
            type: Boolean,
            required: true
        },
        isDefaultLocked: {
            type: Boolean,
            required: false,
            default: false
        },
        isAvailableToPay: {
            type: Boolean,
            required: true
        },
        minWithdrawableValue: {
            type: Number,
            required: false
        },
        canDeposit: {
            type: Boolean,
            required: true
        },
        isPaymentDataLoading: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        withdrawable() {
            if (this.isPaymentDataLoading)
                return true;
            return this.minWithdrawableValue !== undefined && this.val >= this.minWithdrawableValue;
        },
        multiAssetCoins() {
            return BASE_CONSTANTS.ADDITIONAL_ASSETS;
        },
        tooltipText() {
            return BigNumber(this.val).isZero() ? 'Монета доступна в качестве маржинального актива' : 'Монета доступна в качестве маржинального актива — переведите её на фьючерсный счёт';
        }
    }
});
